
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M5.603 6.559c.438-.284 1.022-.65 1.752-1.098a.84.84 0 00.401-.73L7.72 2.549a.84.84 0 00-.648-.804L4.4 1.116a.84.84 0 00-.99.556c-.938 2.86-.553 5.605 1.155 8.234 1.71 2.633 4.064 4.102 7.065 4.406a.84.84 0 00.907-.666l.541-2.625a.84.84 0 00-.468-.93l-1.996-.93a.84.84 0 00-.793.045 83.73 83.73 0 00-1.776 1.113 7.083 7.083 0 01-1.523-1.684 7.083 7.083 0 01-.919-2.076z"}})])
          )
        }
      }
    